/*
* @描述:
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-11-19 17:47:43
*/
<template>
    <div>
        <el-input v-if="field.field_type==='input'"
                  :placeholder="field.extend.placeholder"
                  disabled></el-input>
        <el-input v-else-if="field.field_type==='textarea'"
                  :placeholder="field.extend.placeholder"
                  :rows="5"
                  disabled
                  type="textarea">
        </el-input>
        <pre v-else-if="field.field_type==='explain'"
             class="explain_wrap"
             v-text="field.extend&&field.extend.explain?field.extend.explain:'请输入说明提示'"></pre>
        <div v-else-if="field.field_type==='number'"
             style="position: relative">
            <el-input :placeholder="field.extend.placeholder"
                      disabled>
                <span v-if="field.extend.unit" slot="suffix" v-text="field.extend.unit"></span>
            </el-input>
        </div>
        <el-input v-else-if="field.field_type==='money'&&field.field_key!=='purchase_price'"
                  :placeholder="field.extend.placeholder"
                  class="money_input"
                  disabled>
            <el-input slot="suffix"
                      disabled
                      placeholder="请选择币种"
                      style="width: 160px"
                      suffix-icon="el-icon-arrow-down">
            </el-input>
        </el-input>
        <el-input v-else-if="field.field_type==='compute_mode'"
                  disabled
                  placeholder="系统自动计算">
        </el-input>
        <el-input v-else-if="field.field_type==='duration'"
                  disabled
                  placeholder="系统自动带出">
        </el-input>
        <el-input v-else-if="field.field_type==='telephone'"
                  :placeholder="field.extend.placeholder"
                  class="telephone_input"
                  disabled>
            <el-input
                    slot="prepend"
                    :placeholder="field.extend.phone_type==='1'?'+86':'区号'"
                    disabled
                    style="width: 120px">
            </el-input>
        </el-input>
        <el-select v-else-if="field.field_type==='radio'"
                   v-model="field.field_value"
                   :placeholder="field.extend.placeholder"
                   disabled>
            <el-option v-for="radio in field.extend.options"
                       :label="radio.label"
                       :value="radio.value">
            </el-option>
        </el-select>
        <el-select v-else-if="field.field_type==='radio_workorder_type'"
                   v-model="field.field_value"
                   :placeholder="field.extend.placeholder"
                   disabled>
            <el-option v-for="radio in field.extend.options"
                       :label="radio.label"
                       :value="radio.value">
            </el-option>
        </el-select>
        <el-select
                v-else-if="field.field_type==='checkbox'||field.field_type==='checkbox_user_tag'||field.field_type==='checkbox_quotation'"
                v-model="field.field_value"
                :placeholder="field.extend.placeholder"
                disabled
                multiple>
            <el-option v-for="radio in field.extend.options"
                       :label="radio.label"
                       :value="radio.value">
            </el-option>
        </el-select>
        <el-input v-else-if="field.field_type==='cascader'"
                  :placeholder="field.extend.placeholder"
                  disabled>
        </el-input>
        <el-date-picker v-else-if="field.field_type==='date'"
                        :placeholder="field.extend.placeholder"
                        disabled>
        </el-date-picker>
        <el-date-picker v-else-if="field.field_type==='attendance_date'"
                        :placeholder="field.extend.placeholder"
                        disabled>
        </el-date-picker>
        <div v-else-if="field.field_type==='date_range'"
             class="date_range_input_wrap">
            <el-date-picker :end-placeholder="field.extend.end_placeholder"
                            :start-placeholder="field.extend.start_placeholder"
                            disabled
                            range-separator="-"
                            type="datetimerange">
            </el-date-picker>
            <el-input v-if="field.extend.auto_computed"
                      disabled
                      placeholder="自动计算时长"
                      style="width: 150px">
                <span slot="suffix">天</span>
            </el-input>
        </div>
        <div v-else-if="field.field_type==='date_range_apm'" class="date_range_apm_wrap">
            <div class="flex_wrap">
                <el-date-picker disabled placeholder="请选择开始时间">

                </el-date-picker>
                <span class="line"></span>
                <el-select v-model="date_range_apm">
                    <el-option label="上午" value="1"></el-option>
                    <el-option label="下午" value="2"></el-option>
                </el-select>
            </div>
            <div class="flex_wrap">
                <el-date-picker disabled placeholder="请选择结束时间">
                </el-date-picker>
                <span class="line"></span>
                <el-select v-model="date_range_apm">
                    <el-option label="上午" value="1"></el-option>
                    <el-option label="下午" value="2"></el-option>
                </el-select>
            </div>
        </div>
        <div v-else-if="field.field_type==='address'"
             class="address_input_wrap">
            <el-input :placeholder="field.extend.area_accuracy_placeholder"
                      :style="{'width':field.extend.is_show_detail_address?'200px':'100%'}"
                      disabled
                      suffix-icon="el-icon-arrow-down">
            </el-input>
            <el-input
                    v-if="field.extend.is_show_detail_address"
                    :placeholder="field.extend.detail_address_placeholder"
                    class="mt_15"
                    disabled></el-input>
        </div>
        <div v-else-if="field.field_type==='location'">
            <el-input disabled
                      placeholder="自动定位"
                      suffix-icon="iconfont icon-dingwei"></el-input>
        </div>
        <el-select
                v-else-if="field.field_type==='contact'||field.field_type==='workorder_role'||field.field_type==='department'||field.field_type==='crm_contact'"
                v-model="field.field_value"
                :placeholder="field.extend.placeholder"
                disabled>
            <el-option v-for="radio in field.extend.options"
                       :label="radio.label"
                       :value="radio.value">
            </el-option>
        </el-select>
        <el-select
                v-else-if="field.field_type==='crm_project'||field.field_type==='crm_customer'"
                v-model="field.field_value"
                :placeholder="field.extend.placeholder"
                disabled>
            <el-option v-for="radio in field.extend.options"
                       :label="radio.label"
                       :value="radio.value">
            </el-option>
        </el-select>
        <el-input v-else-if="field.field_type==='serial_number'"
                  class="serial_number_input"
                  disabled
                  placeholder="提交后系统自动生成">
        </el-input>
        <div v-else-if="field.field_type==='table'"
             class="table_outer_wrap">
            <ul :class="`table_${field.extend.filling_method}_list`">
                <draggable :animation="300"
                           :list="field._child"
                           :scroll="true"
                           class="table_drag_wrapper"
                           group="componentsGroup"
                           handle=".table_item"
                           @end="tableListDraggableEnd(field._child)">
                    <template v-if="field._child&&field._child.length">
                        <li v-for="table_item in field._child"
                            :key="table_item.field_key"
                            :class="{'active':table_item.field_key===componentPropertyForm.field_key}"
                            class="table_item"
                            @click.stop="handleClickTableFieldItem(table_item)">
                            <div class="table_item_wrap">
                                <div class="table_item_top">
                                    <div v-text="table_item.field_name"></div>
                                    <div class="flex_wrap">
                                        <el-checkbox
                                                v-model="table_item.is_required"
                                                :disabled="table_item.is_system===1||table_item.field_type==='serial_number'||table_item.field_type==='compute_mode'"
                                                :false-label="0"
                                                :true-label="1"
                                                @change="handleFieldIsRequiredChange(table_item)"
                                                @click.stop>必填
                                        </el-checkbox>
                                        <span class="handle_icon_wrap handle_icon_danger_wrap"
                                              @click.stop="handleClickDeleteTableField(table_item,field._child)">
                                            <i class="el-icon-remove"></i>
                                        </span>
                                    </div>
                                </div>
                                <div v-if="field.extend.filling_method==='horizontal'">
                                    <el-input
                                            v-if="table_item.field_type==='input'||table_item.field_type==='textarea'||table_item.field_type==='number'"
                                            :placeholder="table_item.extend.placeholder"
                                            readonly>
                                    </el-input>
                                    <el-input
                                            v-else-if="table_item.field_type==='money'"
                                            :placeholder="table_item.extend.placeholder"
                                            class="money_input"
                                            readonly>
                                        <el-input slot="suffix"
                                                  :style="{'width': field.extend.filling_method==='horizontal'?'77px':'160px'}"
                                                  disabled
                                                  placeholder="币种"
                                                  suffix-icon="el-icon-arrow-down">
                                        </el-input>
                                    </el-input>
                                    <el-input
                                            v-else-if="table_item.field_type==='compute_mode'"
                                            disabled
                                            placeholder="系统自动计算"
                                            readonly>
                                    </el-input>
                                    <el-input
                                            v-else-if="table_item.field_type==='telephone'"
                                            :placeholder="table_item.extend.placeholder"
                                            class="telephone_input"
                                            disabled>
                                        <el-input
                                                slot="prepend"
                                                :placeholder="table_item.extend.phone_type==='1'?'+86':'区号'"
                                                :style="{'width': field.extend.filling_method==='horizontal'?'60px':'120px'}"
                                                disabled>
                                        </el-input>
                                    </el-input>
                                    <el-select
                                            v-else-if="table_item.field_type==='radio'||table_item.field_type==='checkbox'||table_item.field_type==='cascader'||table_item.field_type==='contact'||table_item.field_type==='department'"
                                            v-model="table_item.field_value"
                                            :placeholder="table_item.extend.placeholder"
                                            disabled>
                                        <el-option
                                                v-for="radio in table_item.extend.options"
                                                :label="radio.label"
                                                :value="radio.value">
                                        </el-option>
                                    </el-select>
                                    <el-date-picker
                                            v-else-if="table_item.field_type==='date'"
                                            :placeholder="table_item.extend.placeholder"
                                            disabled>
                                    </el-date-picker>
                                    <el-date-picker
                                            v-else-if="table_item.field_type==='date_range'"
                                            :end-placeholder="table_item.extend.end_placeholder"
                                            :start-placeholder="table_item.extend.start_placeholder"
                                            disabled
                                            range-separator="-"
                                            type="datetimerange">
                                    </el-date-picker>
                                    <div v-else-if="table_item.field_type==='address'"
                                         class="address_input_wrap">
                                        <el-input :placeholder="table_item.extend.area_accuracy_placeholder"
                                                  :style="{'width':table_item.extend.is_show_detail_address?'200px':'100%'}"
                                                  disabled
                                                  suffix-icon="el-icon-arrow-down">
                                        </el-input>
                                        <el-input
                                                v-if="table_item.extend.is_show_detail_address"
                                                :placeholder="table_item.extend.detail_address_placeholder"
                                                class="mt_15"
                                                disabled></el-input>
                                    </div>
                                    <div v-else-if="table_item.field_type==='location'">
                                        <el-input disabled
                                                  placeholder="自动定位"
                                                  suffix-icon="iconfont icon-dingwei"></el-input>
                                    </div>
                                    <div v-else-if="table_item.field_type==='image'" class="relate_field_wrap">
                                        <i class="el-icon-plus"></i>
                                        <span>上传图片</span>
                                    </div>
                                    <div v-else-if="table_item.field_type==='file'" class="relate_field_wrap">
                                        <i class="iconfont icon-upload"></i>
                                        <span>上传附件</span>
                                    </div>
                                    <div v-else-if="table_item.field_type==='invoice'" class="relate_field_wrap">
                                        <i class="iconfont icon-upload"></i>
                                        <span>上传发票</span>
                                    </div>
                                    <div v-else-if="table_item.field_type==='checkbox_approval'"
                                         class="relate_field_wrap">
                                        <i class="el-icon-plus"></i>
                                        <span>{{table_item.field_name}}</span>
                                    </div>
                                    <div v-else-if="table_item.field_type==='checkbox_check_record'"
                                         class="relate_field_wrap">
                                        <i class="el-icon-plus"></i>
                                        <span>打卡记录</span>
                                    </div>
                                    <el-input v-else-if="table_item.field_type==='paying_teller'"
                                              :placeholder="table_item.extend.placeholder"
                                              disabled
                                              suffix-icon="iconfont icon-saoyisao"></el-input>
                                    <div v-else-if="table_item.field_type==='id_card'" class="id_card_wrap">
                                        <el-input :placeholder="table_item.extend.placeholder" disabled>
                                            <span slot="suffix">
                                                <i v-if="table_item.extend.upload_recognition"
                                                   class="iconfont icon-saoyisao"></i>
                                                <i v-if="table_item.extend.name_is_show||table_item.extend.address_is_show||table_item.extend.birthday_is_show"
                                                   class="iconfont icon-shenfenzheng"></i>
                                                <i v-if="table_item.extend.data_desensitization"
                                                   class="iconfont icon-yanjing"></i>
                                            </span>
                                        </el-input>
                                    </div>
                                    <div v-else-if="table_item.field_type==='rate'" class="rate_wrap">
                                        <el-rate v-model="rateValue"
                                                 disabled
                                                 text-color="#333333">
                                        </el-rate>
                                        <span class="rate_value" v-text="table_item.extend.point_system + '分'"></span>
                                    </div>
                                </div>
                                <div v-else>
                                    <customField :field="table_item"/>
                                </div>
                            </div>
                        </li>
                    </template>
                    <div v-else class="table_empty_hint">拖拽控件至此处添加</div>
                </draggable>
            </ul>
        </div>
        <div v-else-if="field.field_type==='control_group'">
            <ul class="control_group_list">
                <li class="control_group_item">
                    <div v-for="child in field._child.filter(child=>!child.extend.initial_display)" :key="child.field_key" class="mb_12">
                        <div class="center_field_label">
                            <div :class="{'is_required':child.is_required===1}"
                                 class="field_name_wrap">
                                <span class="field_name" v-text="child.field_name"></span>
                            </div>
                            <div class="flex_wrap">
                                <el-checkbox v-if="child.extend.hasOwnProperty('can_set_required')"
                                             v-model="child.is_required"
                                             :false-label="0"
                                             :true-label="1"
                                             @click.stop>必填
                                </el-checkbox>
                                <span v-if="child.extend.hasOwnProperty('is_show_switch')"
                                      class="handle_icon_wrap handle_icon_danger_wrap"
                                      @click.stop="handleClickDeleteControlGroupField(child)">
                                    <i class="el-icon-remove"></i>
                                </span>
                            </div>
                        </div>
                        <customField :field="child"/>
                    </div>
                </li>
            </ul>
            <div class="ta_c">
                <el-button v-if="field.extend.is_many_stroke_submit"
                           icon="el-icon-plus"
                           plain
                           size="mini"
                           type="primary">添加行程</el-button>
            </div>
        </div>
        <el-table v-else-if="field.field_type==='goods'" :data="goodsList" border class="goods_table">
            <el-table-column label="产品名称" min-width="141" prop="goods_name"></el-table-column>
            <el-table-column label="销售/租借" min-width="144">
                <template slot-scope="{row}">
                    <el-radio-group v-model="row.type">
                        <el-radio label="1">销售</el-radio>
                        <el-radio label="2">租借</el-radio>
                    </el-radio-group>
                </template>
            </el-table-column>
            <el-table-column align="right" label="成本" min-width="80" prop="cost"></el-table-column>
            <el-table-column align="right" label="指导单价" min-width="80" prop="guide_price"></el-table-column>
            <el-table-column align="right" label="单价" min-width="66" prop="price"></el-table-column>
            <el-table-column fixed="right" label="" width="10"></el-table-column>
        </el-table>
        <el-table v-else-if="field.field_type==='purchase_details'" :data="purchaseDetailsList" border
                  class="goods_table">
            <el-table-column label="产品名称" min-width="124" prop="product_name"></el-table-column>
            <el-table-column align="right" label="数量" prop="num" width="110"></el-table-column>
            <el-table-column align="right" label="单价（元）" prop="price" width="96"></el-table-column>
            <el-table-column align="right" label="小计金额（元）" prop="total_price" width="124"></el-table-column>
            <el-table-column v-if="field.extend.show_field.indexOf('stock') > -1" label="入库仓库" prop="stock_id"
                             width="150"></el-table-column>
            <el-table-column v-if="field.extend.show_field.indexOf('note') > -1" label="说明" prop="note"
                             width="164"></el-table-column>
            <el-table-column fixed="right" label="" width="10"></el-table-column>
        </el-table>
        <div v-else-if="field.field_type==='money_compute_mode'">
            <div v-if="field.field_key==='total_price'" class="flex_js_wrap">
                <el-button icon="el-icon-plus" type="text">添加产品</el-button>
                <div class="money_compute_mode_text">订单总金额：</div>
            </div>
            <div v-else-if="field.field_key==='payable_amount'">
                <el-input :placeholder="field.extend.filling_method==='1'?'系统自动算出': field.extend.placeholder"
                          class="money_input"
                          disabled>
                    <el-input slot="suffix"
                              disabled
                              placeholder="请选择币种"
                              style="width: 160px"
                              suffix-icon="el-icon-arrow-down">
                    </el-input>
                </el-input>
            </div>
        </div>
        <div v-else-if="field.field_type==='image'"
             class="image_outer_wrap">
            <div class="image_upload_wrap">
                <i class="el-icon-plus"></i>
            </div>
            <p class="image_hint">从本地上传图片，支持多张上传、多种图片格式。</p>
        </div>
        <div v-else-if="field.field_type==='file'" class="file_outer_wrap">
            <img alt=""
                 src="https://download.hecoos.com/enlightv/2023-31/3wy8ZnscPAjXMD2XmQhb.png"
                 width="36">
            <p class="file_hint">点击或者将文件拖拽到这里上传</p>
            <p class="file_type_hint">支持Word、Excel、PDF等常见类型</p>
        </div>
        <div v-else-if="field.field_type==='invoice'"
             class="upload_btn_outer_wrap">
            <div class="add_btn"><i class="iconfont icon-upload"></i>上传发票
            </div>
        </div>
        <div v-else-if="field.field_type==='checkbox_approval'"
             class="upload_btn_outer_wrap">
            <div class="add_btn"><i class="el-icon-plus"></i>{{field.field_name}}
            </div>
        </div>
        <div v-else-if="field.field_type==='checkbox_check_record'">
            <p class="checkbox_check_record_hint">如需新增打卡记录，请前往移动端</p>
            <div class="upload_btn_outer_wrap">
                <div class="add_btn"><i class="el-icon-plus"></i>打卡记录
                </div>
            </div>
        </div>
        <el-input v-else-if="field.field_type==='paying_teller'"
                  :placeholder="field.extend.placeholder"
                  disabled
                  suffix-icon="iconfont icon-saoyisao"></el-input>
        <div v-else-if="field.field_type==='id_card'" class="id_card_wrap">
            <el-input :placeholder="field.extend.placeholder" disabled>
                <span slot="suffix">
                    <i v-if="field.extend.upload_recognition"
                       class="iconfont icon-saoyisao"></i>
                    <i v-if="field.extend.name_is_show||field.extend.address_is_show||field.extend.birthday_is_show"
                       class="iconfont icon-shenfenzheng"></i>
                    <i v-if="field.extend.data_desensitization"
                       class="iconfont icon-yanjing"></i>
                </span>
            </el-input>
        </div>
        <div v-else-if="field.field_type==='rate'" class="flex_wrap">
            <el-rate v-model="rateValue"
                     disabled
                     text-color="#333333">
            </el-rate>
            <span v-text="field.extend.point_system + '分'"></span>
        </div>
        <el-select v-else-if="field.field_type==='customer_contact'"
                   v-model="field.field_value"
                   :placeholder="field.extend.placeholder"
                   disabled>
            <el-option v-for="radio in field.extend.options"
                       :label="radio.label"
                       :value="radio.value">
            </el-option>
        </el-select>
        <el-select v-else-if="field.field_type==='radio_project_stage'"
                   v-model="field.field_value"
                   :placeholder="field.extend.placeholder"
                   disabled>
            <el-option v-for="radio in field.extend.options"
                       :label="radio.label"
                       :value="radio.value">
            </el-option>
        </el-select>
        <el-select v-else-if="field.field_type==='radio_customer'"
                   v-model="field.field_value"
                   :placeholder="field.extend.placeholder"
                   disabled>
            <el-option v-for="radio in field.extend.options"
                       :label="radio.label"
                       :value="radio.value">
            </el-option>
        </el-select>
        <el-select v-else-if="field.field_type==='radio_project'"
                   v-model="field.field_value"
                   :placeholder="field.extend.placeholder"
                   disabled>
            <el-option v-for="radio in field.extend.options"
                       :label="radio.label"
                       :value="radio.value">
            </el-option>
        </el-select>
        <el-select v-else-if="field.field_type==='radio_order'"
                   v-model="field.field_value"
                   :placeholder="field.extend.placeholder"
                   disabled>
            <el-option v-for="radio in field.extend.options"
                       :label="radio.label"
                       :value="radio.value">
            </el-option>
        </el-select>
        <el-input v-else-if="field.field_type==='order_amount_compute_mode'"
                  :placeholder="field.extend.filling_method==='1'?'自动算出':'请输入'+field.field_name" disabled></el-input>
    </div>
</template>
<script>
    import draggable from "vuedraggable";
    import customField from "@/components/pComponents/customField";location

    export default {
        name: "customField",
        components: {draggable, customField},
        data() {
            return {
                rateValue: 5,
                goodsList: [
                    {
                        goods_name: '小米手机156G白色',
                        type: '1',
                        cost: '自动带出',
                        guide_price: '自动带出',
                        price: '请输入',
                    }
                ],
                purchaseDetailsList: [
                    {
                        product_name: '请输入采购产品',
                        num: '请输入数量',
                        price: '请输入单价',
                        total_price: '系统计算',
                        stock_id: '请选择',
                        note: '请输入',

                    }
                ],
                date_range_apm: '上午'
            }
        },
        props: {
            field: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            field_form: {
                type: String,
                default: ''
            },
            componentPropertyForm: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {
            //明细列表排序事件
            tableListDraggableEnd(children) {
                children.forEach((child, index) => {
                    child.sort = index + 1
                })
            },

            handleClickTableFieldItem(table_item) {
                this.$emit('handleClickTableFieldItem', table_item)
            },

            //删除明细列表字段
            handleClickDeleteTableField(table_item, list) {
                this.$emit('handleClickDeleteTableField', table_item, list)
            },

            //删除明细列表字段
            handleFieldIsRequiredChange(table_item) {
                this.$emit('handleFieldIsRequiredChange', table_item)
            },

            //删除控件组字段
            handleClickDeleteControlGroupField(field) {
                this.$emit('handleClickDeleteControlGroupField', field)
            },
        },
    }
</script>
<style lang="scss" scoped>
    ::v-deep .telephone_input .el-input-group__prepend {
        padding: 0;
        border: none;
    }

    ::v-deep .el-input.is-disabled .el-input__inner {
        cursor: pointer;
        background-color: #ffffff;
        border-color: #E4E7ED !important;
    }

    ::v-deep .serial_number_input.is-disabled .el-input__inner {
        cursor: pointer;
        background: #F7F8FA !important;
        border-color: #D9D9D9 !important;
        color: #999999;
    }

    ::v-deep .el-textarea.is-disabled .el-textarea__inner {
        cursor: pointer;
        background-color: #ffffff;
        border-color: #E4E7ED !important;
    }

    ::v-deep .el-range-editor.is-disabled {
        cursor: pointer;
        background-color: #ffffff;
        border-color: #E4E7ED !important;

        input {
            cursor: pointer;
            background-color: #ffffff;
            border-color: #E4E7ED !important;
        }
    }

    ::v-deep .el-input.is-disabled .el-input__icon {
        cursor: pointer;
        display: inline-block;
        width: 30px;
    }

    ::v-deep .money_input .el-input__suffix {
        right: 0;
    }

    .el-select {
        width: 100%;
    }

    .el-date-editor.el-input {
        width: 100%;

        ::v-deep .el-input__inner {
            padding: 0 28px;
        }

        ::v-deep .el-input__prefix {
            color: #666666;
        }
    }

    .el-date-editor {
        height: 32px;
        width: 100%;
    }

    .address_input_wrap {
        display: flex;
        gap: 8px;
    }

    .date_range_input_wrap {
        display: flex;
        gap: 8px;

        ::v-deep .el-input__suffix {
            top: 1px;
        }
    }

    .explain_wrap {
        width: 100%;
        border-radius: 4px;
        background: #EDF0F4;
        padding: 8px 12px;
        color: #666666;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0;
        line-height: 22px;
        white-space: normal;
    }

    .image_outer_wrap {
        padding-left: 6px;

        .image_upload_wrap {
            width: 48px;
            height: 48px;
            opacity: 1;
            border-radius: 4px;
            background: #EDF0F4;
            border: 1px dashed #D9D9D9;
            text-align: center;
            line-height: 48px;
            margin-bottom: 2px;
        }

        .image_hint {
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: #999999;
        }
    }

    .file_outer_wrap {
        height: 156px;
        opacity: 1;
        border-radius: 6px;
        background: #EDF0F4;
        border: 1px dashed #D9D9D9;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .file_hint {
            margin-top: 12px;
            margin-bottom: 4px;
            line-height: 22px;
            color: #666666;
        }

        .file_type_hint {
            color: #999999;
            font-size: 12px;
            line-height: 18px;
        }
    }

    .upload_btn_outer_wrap {
        display: flex;
        justify-content: center;

        .add_btn {
            width: fit-content;
            padding: 0 24px;
            border-radius: 4px;
            border: 1px solid #1990FF;
            color: #1990ff;
            line-height: 22px;
            cursor: pointer;

            i {
                font-size: 14px;
                margin-right: 8px;
                vertical-align: middle;
            }
        }
    }

    .id_card_wrap {
        .el-input__suffix {
            .iconfont {
                margin: 0 4px;
                cursor: pointer;
                color: #666666;
            }
        }
    }

    .table_outer_wrap {
        width: 100%;
        border-radius: 6px;
        background: #F7F8FA;
        border: 1px dashed #D9D9D9;

        .table_empty_hint {
            width: 100%;
            height: 22px;
            opacity: 1;
            font-size: 14px;
            line-height: 22px;
            color: #999999;
            text-align: center;
            vertical-align: top;
        }

        .table_horizontal_list {
            width: 100%;
            height: 90px;
            overflow-y: hidden;
            overflow-x: auto;

            .table_drag_wrapper {
                height: 100%;
                display: flex;
                align-items: center;
                padding: 0 4px;

                .table_item {
                    width: 220px;
                    min-width: 206px;
                    height: 100%;
                    padding: 4px;

                    &:hover .table_item_wrap {
                        border-radius: 6px;
                        background: rgba(0, 0, 0, 0.04);
                    }

                    &.active .table_item_wrap {
                        border-radius: 6px;
                        background: rgba(41, 144, 255, 0.08);
                    }

                    .table_item_wrap {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        padding: 4px;

                        .table_item_top {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;

                            .el-icon-remove {
                                color: #BFBFBF;
                                cursor: pointer;
                            }
                        }

                        .rate_wrap {
                            height: 32px;
                            display: flex;
                            padding: 5px 8px;
                            border-radius: 4px;
                            background: #FFFFFF;
                            border: 1px solid #D9D9D9;
                            align-items: center;

                            ::v-deep .el-rate {
                                height: 22px;
                                display: flex;
                                align-items: center;
                                gap: 8px;

                                .el-rate__item {
                                    height: 22px;
                                    width: 22px;
                                    text-align: center;
                                    line-height: 22px;

                                    .el-rate__icon {
                                        margin-right: 0;
                                        vertical-align: middle;
                                        font-size: 16px;
                                    }
                                }
                            }

                            .rate_value {
                                display: inline-block;
                                line-height: 22px;
                                vertical-align: middle;
                            }
                        }

                        .relate_field_wrap {
                            height: 32px;
                            border-radius: 4px;
                            background: #FFFFFF;
                            border: 1px solid #D9D9D9;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            gap: 8px;
                            color: #666666;

                            i {
                                font-size: 14px;
                            }

                            span {
                                line-height: 18px;
                                font-size: 12px;
                            }
                        }
                    }
                }
            }
        }

        .table_vertical_list {
            width: 100%;
            height: 300px;

            .table_drag_wrapper {
                width: 100%;
                height: 100%;
                overflow-y: auto;
                padding: 8px;

                .table_item {
                    width: 100%;

                    &:hover .table_item_wrap {
                        border-radius: 6px;
                        background: rgba(0, 0, 0, 0.04);
                    }

                    &.active .table_item_wrap {
                        border-radius: 6px;
                        background: rgba(41, 144, 255, 0.08);
                    }

                    .table_item_wrap {
                        width: 100%;
                        padding: 4px 8px 8px;

                        .table_item_top {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;

                            .el-icon-remove {
                                color: #BFBFBF;
                                cursor: pointer;
                                margin-left: 12px;
                            }
                        }
                    }
                }
            }
        }
    }

    ::v-deep .goods_table {
        border-radius: 6px 6px 0 0;

        .el-table__header {
            tr th {
                padding: 0;
                height: 38px;
                background-color: #EDF0F4;
                border-color: rgba(0, 0, 0, 0.04);

                &:first-child {
                    border-radius: 6px 0 0 0;
                }

                &:last-child {
                    border-radius: 0 6px 0 0;
                }

                .cell {
                    line-height: 22px;
                    font-weight: normal;
                    color: #333333;
                }
            }
        }

        tr td {
            .cell {
                line-height: 21px;
                color: #666666;
            }
        }
    }

    .money_compute_mode_text {
        color: #333333;
        font-weight: bold;
    }

    .date_range_apm_wrap {
        display: flex;
        align-items: center;
        background-color: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #D9D9D9;
        gap: 8px;

        .flex_wrap {
            flex: 1;
        }

        ::v-deep .el-input__inner {
            border: none;
        }

        ::v-deep .el-date-editor {
            flex: 1;
        }

        ::v-deep .el-select {
            width: 60px;

            .el-input__inner {
                padding: 0;
            }
        }
    }

    .center_field_label {
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 22px;
        margin-bottom: 4px;

        .el-icon-remove {
            color: #BFBFBF;
            font-size: 16px;
            cursor: pointer;

            &.is_disabled {
                color: #D9D9D9;
            }
        }

        .field_name_wrap {
            line-height: 22px;
            position: relative;

            &.is_required::before {
                content: '*';
                position: absolute;
                left: 0;
                color: #E44144;
            }

            .field_name {
                color: #333333;
                display: inline-block;
                line-height: 22px;
                padding-left: 5px;
            }
        }

        ::v-deep .el-checkbox {
            margin-right: 16px;
        }

        .page_little_title {
            margin-bottom: 0;
        }
    }
</style>
